import styled from '@emotion/styled';
import React from 'react';
import { Text3 } from '../../components/typography/Text3';
import VerticalFlex from '../../components/flex_layouts/VerticalFlex';
import Colors from '../../components/theme/colors';

const DescriptionSection = ({ ...props }) => {
  return (
    <LayoutRoot {...props}>
      <MainContainer>
        <Text3>
          The PROphet<R>®</R> platform combines bioinformatics, system biology, proteomic pattern recognition and
          machine learning in a cancer patient’s plasma to predict clinical benefit probability (at least 12 months
          progression-free survival) in response to PD-1/PD-L1 inhibitors and lists clinical evidence-based treatment
          considerations.
        </Text3>
        <Text3>
          Treatment options listed here include approved and recruiting investigational (Phase II/III) therapies for
          NSCLC. All treatment options are based on PD-1/PD-L1 inhibitors in combination with another agent or treatment
          modality. Treatments are listed with reference to the biological mechanism targeted by the therapeutic agent
          or treatment modality.
        </Text3>
      </MainContainer>
    </LayoutRoot>
  );
};

export default DescriptionSection;

const LayoutRoot = styled.section`
  padding: 0 70px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 1044px) {
    padding: 0 16px;
  }

  @media print {
    padding: 8px;
  }
`;

const MainContainer = styled(VerticalFlex)`
  padding: 45px 88px;
  margin-top: -130px;
  align-items: center;
  max-width: 1320px;
  gap: 20px;
  background-color: white;
  border-radius: 15px;
  box-shadow: 0px 20px 100px 0px rgba(65, 132, 247, 0.1);

  @media (max-width: 1044px) {
    max-width: none;
    padding: 20px;
  }

  @media print {
    box-shadow: none;
    border: 1px solid ${Colors.gray_4};
    padding: 8px;
    gap: 8px;
    margin-top: -148px;
  }
`;

const R = styled('span')`
  vertical-align: super;
  font-size: 14px;

  @media print {
    font-size: 10px;
  }
`;
